import axios from 'axios'
import {GeoJsonLayer} from '@deck.gl/layers';
import {FillStyleExtension} from '@deck.gl/extensions';
import {PRIKAZ10_MAPPING, PRIKAZ10_HASH} from '../prikaz10';
import * as turf from '@turf/turf'

// export const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const IS_DEV = false

const EBUS = document.body.childNodes[1]

export const broadcast = (type, data) => {
  EBUS.dispatchEvent(new CustomEvent(type, {detail: data}))
}
export const listen = (type, fnc) => EBUS.addEventListener(type, fnc)
export const stop_listen = (type, fnc) => EBUS.removeEventListener(type, fnc)

const origin = window.location.origin.replace("3000", "4000")

var back_url = `${origin.replace("http://", "http://back.")}/api/graphql`

if (IS_DEV)
  back_url = `${origin}/api/graphql`

export const post_gql = (query, fnc, headers = false) => {
  if (headers){
    axios.post(back_url, {query: query}, {headers: headers}).then(fnc).catch(error => console.log(error))
  } else {
    axios.post(back_url, {query: query}).then(fnc).catch(error => console.log(error))
  }
}

export const create_attach = (formdata, fnc, headers, on_upload, on_error) => {
  const attach_url = back_url.replace("/api/graphql", "/attach")
    axios.post(
      attach_url,
      formdata,
      {headers: headers, onUploadProgress: on_upload}
    ).then(fnc).catch(on_error)
}

export const INIT_POLYGON_SETTINGS = {
  color: "#264653",
  radius: 50,
  opacity: 70,
  border_width: 2,
  border_opacity: 100,
  border_color: "#e74c3c",
  pattern: 'none',
  pattern_scale: 1
}

const icon = "602010407_рек_фз"

export const INIT_POINT_SETTINGS = {
  icon_atlas: `/${PRIKAZ10_HASH[icon.split("_")[0]].group}.png`,
  icon_mapping: PRIKAZ10_MAPPING,
  icon: icon,
  size:	50,
  // opacity: 100,
  tooltip_text: "введите текст тултипа",
  angle:	0,
  min_pixels:	0,
  max_pixels:	9999999,
}

export const INIT_VIDEO_SETTINGS = {
  url: "",
  coord1: [],
  coord2: [],
  coord3: [],
  coord4: [],
  min_zoom: 0,
  max_zoom: 22
}

export const INIT_TEXT_SETTINGS = {
  color: "#000000",
  opacity: 100,
  text: "Введите текст",
  size: 120,
  anchor: 'middle',
  alignment_baseline: 'center',
  angle: 0,
  font_family: 'Monaco',
  font_weight: "400",
  max_width: -1,
  word_break: 'break-word',
  background_padding_left: 10,
  background_padding_right: 10,
  background_padding_top: 10,
  background_padding_bottom: 10,
  background_color: "#ffffff",
  background_opacity: 10,
  border_color: "#ffffff",
  border_opacity: 30,
  border_width: 10,
  outline_color: "#ffffff",
  outline_opacity: 0,
  outline_width: 0
}

export const makeid = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    // const characters = 'ABCDEF0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

export const hexToRgb = (hex) =>  {
  var res = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return res ? [parseInt(res[1], 16), parseInt(res[2], 16), parseInt(res[3], 16)] : null
}

export const polygon_layer = (props, type = "Polygon") => {
  var data = []
  var coords = props.coords

  if (coords.length === 0)
    coords = props.coords_multi

  if (type === 'Polygon') {
    data = turf.polygon(coords, {polygon_settings: props.polygon_settings, id: props.id})
  } else if (type === "MultiPolygon") {
    data = turf.multiPolygon(coords, {polygon_settings: props.polygon_settings, id: props.id})
  }

  return(
    new GeoJsonLayer({
      id: props.id,
      data: data,
      filled: true,
      getFillColor: object => [...hexToRgb(object.properties.polygon_settings.color), Math.round(255 * object.properties.polygon_settings.opacity / 100)],
      getFillOpacity: object => object.properties.polygon_settings.opacity / 100,
      getLineWidth: object => object.properties.polygon_settings.border_width,
      getLineColor: object => [...hexToRgb(object.properties.polygon_settings.border_color), Math.round(255 * object.properties.polygon_settings.border_opacity / 100)],
      pickable: true,


      // props added by FillStyleExtension
      fillPatternEnabled: !(!props.polygon_settings.pattern || props.polygon_settings.pattern === 'none'),
      fillPatternMask: true,
      fillPatternAtlas: '/pattern4.png',
      fillPatternMapping: '/pattern.json',
      getFillPattern: object => {
        return(
          {
            dots: 'dots',
            hatch: 'hatch-cross',
            x1: 'hatch-1x',
            x2: 'hatch-2x'
          }[object.properties.polygon_settings.pattern]
        )
      },
      getFillPatternScale: object => object.properties.polygon_settings.pattern_scale,
      getFillPatternOffset: [0, 0],

      // Define extensions
      extensions: [new FillStyleExtension({pattern: true})]
    })
  )
}


export const marker_layer = (coords, settings) => {
  const data = turf.point(coords, {point_settings: settings.point_settings, id: settings.id})
  // console.log(data)

  return(
    new GeoJsonLayer({
      id: data.properties.id,
      data: data,
      pickable: true,
      pointType: "icon",
      iconAtlas: `/${PRIKAZ10_HASH[data.properties.point_settings.icon.split("_")[0]].group}.png`,
      iconMapping: PRIKAZ10_MAPPING,
      getIcon: o => o.properties.point_settings.icon,
      getIconSize: o => o.properties.point_settings.size,
      // getIconColor: o => [...hexToRgb(o.properties.point_settings.color), Math.round(255 * o.properties.point_settings.opacity / 100)],
      getIconAngle: o => o.properties.point_settings.angle,
      iconSizeUnits: "meters",
      iconSizeMinPixels: data.properties.point_settings.min_pixels,
      iconSizeMaxPixels: data.properties.point_settings.max_pixels
    })
  )
}

export const video_layer = (settings) => {
  const data = turf.polygon(
    [[
      settings.video_settings.coord1,
      settings.video_settings.coord2,
      settings.video_settings.coord3,
      settings.video_settings.coord4,
      settings.video_settings.coord1,
    ]],
    settings
  )

  return(
    new GeoJsonLayer({
      id: settings.id,
      data: data,
      filled: true,
      getFillColor: object => [...hexToRgb("#8a8a8a"), 0],
      getFillOpacity: object => 0,
      lineWidthUnits: "pixels",
      getLineWidth: object => 0,
      getLineColor: object => [...hexToRgb("#5a5a5a"), 200],
      pickable: true,
    })
  )
}

export const video_layer_edges = (id, settings) => {
  [
    settings.coord1,
    settings.coord2,
    settings.coord3,
    settings.coord4
  ].forEach((coords, i) => {
    broadcast(
      "add_or_replace_layer",
      new GeoJsonLayer({
        id: `${id}_${i+1}_video_edge`,
        data: turf.point(coords, {type: "video_edge", object_id: id, index: i+1}),
        getFillColor: [...hexToRgb("#5dade2"), 200],
        getLineWidth: 0,
        pickable: true,
        pointType: "circle",
        getPointRadius: 10,
        pointRadiusUnits: 'pixels',
      })
    )
  })
}

export const chat_layer = (coords, settings) => {
  const data = turf.point(coords, {
    id: settings.id,
    chat_settings: {...settings.chat_settings, user_id: settings.user_id}
  })

  return(
    [
      new GeoJsonLayer({
        id: `${data.properties.id}_1`,
        data: data,
        pickable: true,
        pointType: "icon",
        iconAtlas: settings.chat_settings.picture,
        iconMapping: {"avatar":{"width":96,"y":0,"x":0,"height":96}},
        getIconColor: o => [0,0,0, 200],
        getIcon: o => "avatar",
        getIconSize: o => 32,
        getIconPixelOffset: [2, -4],
        iconSizeUnits: "pixels",
      }),
      new GeoJsonLayer({
        id: data.properties.id,
        data: data,
        pickable: true,
        pointType: "icon",
        iconAtlas: `/chat_custom.png`,
        iconMapping: {"chat_icon":{"width":1300,"y":0,"x":0,"height":1246}},
        getIcon: o => "chat_icon",
        getIconSize: o => 46,
        getIconColor: o => [0,0,0, 150],
        iconSizeUnits: "pixels",
      })
    ]
  )
}


export const text_layer = (coords, settings) => {
  const data = turf.point(coords, {text_settings: settings.text_settings, id: settings.id})
  // console.log(data)

  return(
    new GeoJsonLayer({
      id: data.properties.id,
      data: data,
      pickable: true,
      pointType: "text",
      getText: o => o.properties.text_settings.text,
      getTextColor: o => [...hexToRgb(o.properties.text_settings.color), Math.round(255 * o.properties.text_settings.opacity / 100)],
      getTextAngle: o => o.properties.text_settings.angle,
      getTextSize: o => o.properties.text_settings.size,
      getTextAnchor: o => o.properties.text_settings.anchor,
      getTextAlignmentBaseline: o => o.properties.text_settings.alignment_baseline,
      textSizeUnits: settings.text_settings.textSizeUnits || 'meters',
      textSizeScale: 1,
      textCharacterSet: data.properties.text_settings.text.split(""),
      textFontFamily: data.properties.text_settings.font_family,
      textFontWeight: data.properties.text_settings.font_weight,
      textMaxWidth: data.properties.text_settings.max_width,
      textWordBreak: data.properties.text_settings.word_break,
      textBackground: true, // need for BackgroundColor
      textBackgroundPadding: [
        data.properties.text_settings.background_padding_left,
        data.properties.text_settings.background_padding_top,
        data.properties.text_settings.background_padding_right,
        data.properties.text_settings.background_padding_bottom
      ],
      getTextBackgroundColor: o => [...hexToRgb(o.properties.text_settings.background_color), Math.round(255 * o.properties.text_settings.background_opacity / 100)],
      getTextBorderColor: o => [...hexToRgb(o.properties.text_settings.border_color), Math.round(255 * o.properties.text_settings.border_opacity / 100)],
      getTextBorderWidth: o => o.properties.text_settings.border_width,
      textOutlineColor: [...hexToRgb(data.properties.text_settings.outline_color), Math.round(255 * data.properties.text_settings.outline_opacity / 100)],
      textOutlineWidth: data.properties.text_settings.outline_width,
      textFontSettings: {sdf: true} // need for Outline
    })
  )
}
